import { atom } from 'recoil';

const onlineStatusState = atom({
  key: 'onlineStatusState',
  default: {},
});

export { onlineStatusState };
